import { cloneDeep } from 'lodash';
import { REDUCER_ACTIONS } from './define';
import { getNewAvailableTimes } from './methods';

const reducer = (state, action) => {
    switch (action.type) {
        case REDUCER_ACTIONS.ADD_APPOINTMENTS: {
            return { ...state, appointments: action.payload };
        }
        case REDUCER_ACTIONS.SET_SCHEDULE_EVENTS: {
            const { endDate } = action.payload;
            return { ...state, endDate, scheduleEvents: { ...state.scheduleEvents, [action.payload.id]: action.payload } };
        }
        case REDUCER_ACTIONS.ADD_SCHEDULE_EVENT_AVAILABLE_TIMES: {
            const payload = cloneDeep(action.payload);

            payload.availableTimes = action.payload.availableTimes;

            if (!state.scheduleEvents[action.payload.id])
                return { ...state, scheduleEvents: { ...state.scheduleEvents, [action.payload.id]: payload } };

            const availableTimes = state.scheduleEvents[action.payload.id].availableTimes || [];
            const addingAvailableTimes = action.payload.avalibleTimes;
            const mergeAvailableTimes = getNewAvailableTimes(availableTimes, addingAvailableTimes);

            const { endDate } = action.payload;

            return {
                ...state,
                endDate,
                scheduleEvents: {
                    ...state.scheduleEvents,
                    [action.payload.id]: {
                        ...state.scheduleEvents[action.payload.id],
                        availableTimes: mergeAvailableTimes
                    }
                }
            };
        }
        case REDUCER_ACTIONS.SET_CURRENT_APPOINTMENT: {
            return { ...state, appointment: action.payload };
        }
        default: {
            return state;
        }
    }
};

export default reducer;
